import { useEffect } from "react";

import { ProfileDto } from "@/core/api/generated/v1";
import * as profileSlice from "@/store/profile/slice";

import { useAuthenticationInfo } from "../auth/useAuthenticationInfo";
import { useAppSelector, useAppThunkDispatch } from "../redux";

/** Returns currently authenticated user profile (loads it if not loaded). */
export const useUserProfile = (): ProfileDto | undefined => {
  const dispatch = useAppThunkDispatch();
  const profile = useAppSelector((x) => x.profile.profile);
  const authenticationInfo = useAuthenticationInfo();

  useEffect(() => {
    if (!profile && authenticationInfo.isAuthenticated) {
      dispatch(profileSlice.getProfileThrottle());
    }
  }, [profile, authenticationInfo.isAuthenticated]);

  return profile;
};
